// --- React
import React, { useState } from "react";
// --- Styles
import "./styles.scss";

/**
 * CollapsibleSection Component
 *
 * A section with a header that can be clicked to expand/collapse its content.
 * Used in view drawers for organizing grouped information.
 *
 * @component
 * @param {Object} props - Component properties
 * @param {string} props.title - The section title
 * @param {number} [props.count] - Optional item count to display
 * @param {React.ReactNode} props.children - Content to show when expanded
 * @param {boolean} [props.defaultOpen=true] - Initial expanded state
 * @returns {JSX.Element}
 *
 * @example
 * <CollapsibleSection title="Windows" count={3}>
 *   {windows.map(w => <WindowCard key={w.id} {...w} />)}
 * </CollapsibleSection>
 */
export const CollapsibleSection = ({
  title,
  count,
  children,
  defaultOpen = true,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="collapsible-section">
      <div
        onClick={() => setIsOpen(!isOpen)}
        className="collapsible-section-header"
      >
        <div className="collapsible-section-title-wrapper">
          <span className="collapsible-section-title">{title}</span>
          {count !== undefined && (
            <span className="collapsible-section-count">{count} items</span>
          )}
        </div>
        <i
          className={`fas fa-chevron-${isOpen ? "up" : "down"} collapsible-section-icon`}
        />
      </div>
      {isOpen && <div className="collapsible-section-content">{children}</div>}
    </div>
  );
};

export default CollapsibleSection;
